import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the Progress step on the tab and on every metric under it: Adam Nowak > Progress > Weight. */
export const Route = createFileRoute("/(private)/trainees/$clientId/progress")({
  loader: () => ({ crumb: m.client_tab_progress() }),
  component: Outlet,
});
